export default {
  header: "Select your move!",
  view: "move"
};